import { createApp } from 'vue'
import ElDialog from 'element-plus'
import ElIcons from '../../components/ElIcons'
import ElButtons from '../../components/ElButtons'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn';
import 'element-plus/dist/index.css'
import UserInfoList from "@/components/resume/UserInfoList";
import HeadImg from "@/components/HeadImg";

function makeDialog(option) {
  var dom = document.createElement('div');
  document.getElementsByTagName('body')[0].appendChild(dom);

  //动态创建template
  let tpl = '\
        <el-dialog \
            :width="dialogWidth"\
            :top="dialogTop"\
            :close-on-click-modal="true" \
            :custom-class="customClass" \
            :title="title" \
            v-model="show" \
            :before-close="handleClose" \
            @close="close">\
                <dialogContent  @close="closeDialog" @confirm="confirmDialog" :value="dialogData"></dialogContent>\
        </el-dialog>';

  //创建一个Vue实例
  const app = createApp({
    data () {
      return {
        //从调用文件获取(参数传入)
        title: option.title,
        show: true,
        dialogData: option.data,
        dialogWidth: '675px',
        dialogTop: '10vh'
      };
    },
    template: tpl,
    computed: {
      customClass(){
        return `el-dialog--width-${option.size || 'auto'}`;
      }
    },
    methods: {
      handleClose(done){
        const a = document.getElementsByClassName('el-image-viewer__wrapper')[0];
        if(!a) {
          if (option.beforeClose) {
            option.beforeClose(done);
          } else {
            done();
          }
        }
      },
      close() {
        if (option.close) {
          option.close();
        }
        document.getElementsByTagName('body')[0].removeChild(dom);
      },

      closeDialog(){
        this.show = false
      },
      confirmDialog(result){
        this.show = false
        option.confirm && option.confirm(result)
      }
    },
    components: {
      dialogContent: option.component,//传入的内容模块
    },
    created() {
      if(option.data.width){
        this.dialogWidth = option.data.width;
      }
    }
  })
  app.component('ElIcons', ElIcons)
  app.component('ElButtons', ElButtons)
  app.component('UserInfoList', UserInfoList)
  app.component('HeadImg', HeadImg)
  app.use(ElementPlus, { size: 'default', zIndex: 3000, locale: zhCn })
  app.use(ElDialog, { size: 'default', zIndex: 888 }).mount(dom);
  return app;
}

export default {
  open(options){
    return makeDialog(options)
  }
}
